import React from "react";

function Check() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="44"
            fill="none"
            viewBox="0 0 44 44"
        >
            <path
                fill="#DF8D46"
                d="M31.8 17.422c0 .338-.118.624-.354.86L20.572 29.158a1.17 1.17 0 01-.86.354 1.17 1.17 0 01-.86-.354l-6.298-6.298A1.17 1.17 0 0112.2 22c0-.338.118-.624.354-.86l1.72-1.72a1.17 1.17 0 01.86-.354c.338 0 .624.118.86.354l3.718 3.73 8.296-8.308a1.17 1.17 0 01.86-.354c.338 0 .624.118.86.354l1.72 1.72c.234.236.352.524.352.86z"
            ></path>
            <path
                stroke="#DF8D46"
                strokeDasharray="10 10"
                strokeWidth="2"
                d="M1 1H43V43H1z"
            ></path>
        </svg>
    );
}

export default Check;
